import type { ReactElement } from "react";
import { EmptyState, Link, Stack, Surface } from "../ui-kit";
import { PageHeader } from "../shell/PageHeader";

/**
 * Catch-all route.
 *
 * Deep links are resolved client-side, so an unknown path reaches React rather
 * than the origin — this view is what an operator sees for a mistyped or stale
 * URL. The recovery link is a plain anchor on purpose: it is the one place in
 * the app where a full reload is the safer outcome.
 */
export function NotFoundView(): ReactElement {
  return (
    <Stack gap={6}>
      <PageHeader title="Page not found" description="That address does not match any section of the admin portal." />
      <Surface as="section" aria-label="Page not found">
        <EmptyState
          title="Nothing lives at this address"
          description="Check the link, or start again from the users list."
          action={<Link href="/users">Go to Users</Link>}
        />
      </Surface>
    </Stack>
  );
}
